import { ApiConsumes, ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Post, Body, Req, Query, UseInterceptors, UploadedFiles, Get, Param, Res} from '@nestjs/common';
import { CMRFService } from './cmrf.service';
import { CMRFDTO, DeleteDTO } from './dto/cmrf.dto';
import { AllCMRFResponseModel, CMRFResponseModel, SingleCMRFResponseModel } from './dto/cmrf-response-model';


@ApiTags('cmrf')
@Controller('cmrf')
export class CMRFController {
  constructor(
    private cmrfService: CMRFService
  ){}

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Post('/createCMRF') 
  @ApiQuery({name:'apiVersion'})  
  async createCMRF(@Query() queryParam,@Body() cyDto:CMRFDTO,@Req() request:Request): Promise<CMRFResponseModel> {
    try {
        return await this.cmrfService.createCMRF(queryParam, cyDto);                
      } catch (error) {
          return errorHandler(CMRFResponseModel, error);
      }
  }

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })
  @Post('/updateCMRF')
  @ApiQuery({name:'apiVersion'})  
  async updateCMRF(@Query() queryParams, @Body() cyDto:CMRFDTO, @Req() request: Request): Promise<SingleCMRFResponseModel> {
    try {              
      return await this.cmrfService.updateCMRF(queryParams, cyDto, request);
    } catch (error) {
      return errorHandler(SingleCMRFResponseModel, error);
    }
  } 

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Get('/getAllCMRF/:userId')
  @ApiQuery({name:'apiVersion'})
  @ApiQuery({name:'skip'})
  @ApiParam({name:'userId'})
  async getAllCMRF(@Query() queryParams, @Param('userId') userId, @Req() request:Request): Promise<AllCMRFResponseModel> {
    try {
      return await this.cmrfService.getAllCMRF(queryParams,userId,request);
    } catch (error) {
      return errorHandler(AllCMRFResponseModel, error);
    }
  }

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Get('/getCMRFById/:Id')
  @ApiQuery({name:'apiVersion'})
  @ApiParam({name:'Id'})
  async getCMRFById(@Query() queryParams, @Param('Id') Id, @Req() request:Request): Promise<SingleCMRFResponseModel> {
    try {
      return await this.cmrfService.getCMRFById(queryParams,Id,request);
    } catch (error) {
      return errorHandler(SingleCMRFResponseModel, error);
    }
  }
 

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Post('/deleteRecord')
  @ApiQuery({name:'apiVersion'})
  async deleteRecord(@Query() queryParams, @Body() deleteDto:DeleteDTO ,@Req() request:Request): Promise<CMRFResponseModel> {
    try {
      return await this.cmrfService.deleteRecord(queryParams,deleteDto, request);
    } catch (error) {
      return errorHandler(CMRFResponseModel, error);
    }
  }


} 
